<template>
    <div class="intro">
        <h1 class="title">Works</h1>
        <p>PROJECTS THAT I'VE WORK ON</p>
    </div>
    <div class="cards">
        <div v-for="(card, index) in cards" :key="index">
            <div
                class="card"
                :style="{ backgroundImage: 'url' + '(' + card.img + ')' }"
            ></div>
            <div class="grp-title">
                <div class="title">{{ card.title }}</div>
                <a :href="card.url" class="btn">VISIT</a>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from "vue";
export default {
    setup() {
        const cards = ref([
            {
                img: require("@/assets/images/work/918.png"),
                title: "918 Brandsite",
                url: "https://www.918.com/",
            },
            {
                img: require("@/assets/images/work/819.png"),
                title: "918 Botian",
                url: "https://www.ts611.com/",
            },
            {
                img: require("@/assets/images/work/biyo.png"),
                title: "Bi88 Biyou",
                url: "https://pc.taa8545.com/",
            },
            {
                img: require("@/assets/images/work/dayaw.png"),
                title: "DayawTech",
                url: "https://www.dayawtech.com.ph/",
            },
            {
                img: require("@/assets/images/work/skoms.png"),
                title: "SKOMS",
                url: "https://sk.dayawtech.com.ph/",
            },
        ]);

        return {
            cards,
        };
    },
};
</script>
<style lang="scss" scoped>
.intro {
    padding: 0 8vw;
    text-align: center;
    .title {
        color: #ecb365;
    }
    p {
        color: #fff;
        font-weight: lighter;
    }
}
.cards {
    margin: 30px 0;
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .card {
        width: 85vw;
        height: 20vh;
        background: #041c32;
        box-shadow: 0 0 30px #000;
        border-radius: 15px;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }
    .grp-title {
        margin-top: 2vw;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 7px;
        .title {
            color: #ecb365;
            font-size: 20px;
        }
        .btn {
            color: #ecb365;
            border: 2px solid #ecb365;
            padding: 0.5vw 15vw;
            border-radius: 20px;
            text-decoration: none;
        }
    }
}
</style>
